<form #form="ngForm" class="row" autocomplete="false">
  <div class="col-md-5 col-xl-3">
    <spk-card meta="{{ getActionText() }} User" title="{{model.Username}}" [divider]="true">
      <spk-card [class]="'col'" title="{{model.FirstName}} {{model.LastName}}">
        <h6 class="card-subtitle mb-2 text-muted">username: {{model.Username}}</h6>
        <p class="card-text">
          <strong>Email: </strong> <a href="mailto:{{model.Email}}">{{model.Email}}</a>
        </p>
      </spk-card>
      <br />
      <spk-text name="FirstName" [(model)]="model.FirstName"></spk-text>
      <spk-text name="LastName" [(model)]="model.LastName"></spk-text>
      <spk-text name="name" label="Username" [(model)]="model.Username" [autoComplete]="'off'"></spk-text>
      <spk-text name="email" [(model)]="model.Email"></spk-text>
      <spk-checkbox name="LogCommands" [(model)]="model.LogCommands"></spk-checkbox>
      <spk-checkbox name="IsActive" [(model)]="model.Active"></spk-checkbox>
    </spk-card>
  </div>
  <div class="col-md-3 col-xl-2">
    <spk-card title="Roles" [divider]="true">
      <table>
        <thead>
          <tr>
            <th class="col-sm text-left">Role</th>
            <th class="col-sm">Access</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let userRoleDto of model.UserRoleDtos;let index = index;">
            <td style="padding-left: 15px;">{{userRoleDto.RoleName}}</td>
            <td class="text-center">
              <spk-checkbox [name]="'ur' + index" [(model)]="model.UserRoleDtos[index].IsSelected" [wrapped]="false"></spk-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </spk-card>
  </div>
</form>